import { useSettings } from '@wu/widget-core';

const thumbnailModeStyle = {
  margin: '40px',
  boxShadow: '0 6px 30px 0 rgba(0, 0, 0, 0.1)'
};

export function useThumbnailMode() {
  const { renderThumbnailMode: thumbnailMode, widgetBackground } =
    useSettings();
  const { color } = widgetBackground;

  const thumbnailModeBackground = {
    ...widgetBackground,
    borderRadius: 24,
    color: color === 'transparent' ? 'rgb(255, 255, 255)' : color
  };

  return { thumbnailMode, thumbnailModeStyle, thumbnailModeBackground };
}
